import { useEffect } from 'react';
import { useParams } from 'react-router';
import { ActionDialogContext } from '../components/dialogs/Context/ActionDialogContext';
import useActionDialogContextValue from '../components/dialogs/Context/ActionDialogContextValue';
import ApplicantResultsHeader from './Components/ApplicantResultsHeader';
import ResultsPageDialogs from './Components/ResultsPageDialogs';
import ResultsTabContent from './Components/ResultsTabContent';
import { CandidatesResultsContext } from './Contexts/CandidateResultsContext';
import useCandidatesResultsContextValue from './Contexts/useCandidatesResultsContextValue';
import { useJobFunctions } from '@/api/useJobFunctions';
import Page from '@/Components/page';
import { LoadingOverlay } from '@/Components/shared';
import withCompanyProfileRequired from '@/Routing/withCompanyProfileRequired';
import withSignupChecks from '@/Routing/withSignupChecks';
import withTalentMeshUserRequired from '@/Routing/withTalentMeshUserRequired';

interface CandidateResultsPageParams {
    candidateId: string;
    assessmentId: string;
}

function CandidateResultsPage() {
    const contextValue = useCandidatesResultsContextValue();
    const dialogContextValue = useActionDialogContextValue();
    const { data: jobFunctionsMap, isLoading: isJobFunctionsMapLoading } = useJobFunctions();
    const { loadCandidateResultsAsync, isLoading } = contextValue;
    const { assessmentId, candidateId } = useParams<Partial<CandidateResultsPageParams>>();

    useEffect(() => {
        if (!isJobFunctionsMapLoading) {
            loadCandidateResultsAsync(assessmentId!, candidateId!, jobFunctionsMap.jobCategories);
        }
    }, [isJobFunctionsMapLoading, jobFunctionsMap.jobCategories]);

    return (
        <CandidatesResultsContext.Provider value={contextValue}>
            <ActionDialogContext.Provider value={dialogContextValue}>
                <Page>
                    {isLoading ? (
                        <LoadingOverlay />
                    ) : (
                        <div data-cy="pageContentContainer" className="bg-muted flex h-full flex-col overflow-auto">
                            <ApplicantResultsHeader />
                            <div className="container max-w-7xl place-self-center pb-4">
                                <ResultsTabContent />
                                <ResultsPageDialogs />
                            </div>
                        </div>
                    )}
                </Page>
            </ActionDialogContext.Provider>
        </CandidatesResultsContext.Provider>
    );
}

export default withCompanyProfileRequired(withTalentMeshUserRequired(withSignupChecks(CandidateResultsPage)));
